import PropTypes from 'prop-types';
import classnames from 'classnames';

/*
Note: Currently requesting availability of large (1000+) passenger counts is
 expensive in QuickTravel (in the order of minutes)
 A ticket has been lodged in AS-10055
 Meanwhile, a limit has been placed on the steppers to stop users requesting
 arbitraryly large availability.
*/
const DEFAULT_MAX_VALUE = 30;
const INVALID_CHARACTERS = ['e', 'E'];

const StepperField = ({
  field,
  form,
  className,
  onChange,
  onBlur,
  disabled,
  maxValue = DEFAULT_MAX_VALUE,
  minValue = 0,
}) => {
  const enforceRange = (value) => Math.max(Math.min(value, maxValue), minValue);

  // Remove not valid numeric characters
  const returnNumericCharacter = (value) => {
    const numeric = value.toString().replace(/[e]/gi, '');
    if (Number.isNaN(numeric)) return '';
    return numeric;
  };
  const currentValue = field.value || 0;

  return (
    <div className={classnames('input-group', className)}>
      <div className="input-group-prepend">
        <button
          disabled={currentValue === 0 || disabled}
          className="btn button--input-group"
          aria-label="Decrease by 1"
          onClick={() => {
            const newValue = enforceRange(Number(currentValue) - 1);

            form.setFieldValue(field.name, newValue);
            form.setFieldTouched(field.name);
            if (onChange) {
              onChange(newValue);
            }
          }}
          type="button"
        >
          <i className="fal fa-minus" />
        </button>
      </div>
      <input
        className="px-0 form-control form-control--sans-spinner text-center"
        type="number"
        name={field.name}
        id={field.name}
        value={currentValue}
        min={0}
        step={1}
        onKeyDown={(e) =>
          INVALID_CHARACTERS.includes(e.key) && e.preventDefault()
        }
        onChange={(e) => {
          form.setFieldValue(field.name, e.target.value);
          form.setFieldTouched(field.name);
          if (onChange) {
            onChange(e.target.value);
          }
        }}
        onBlur={(e) => {
          const newValue = Math.round(
            enforceRange(returnNumericCharacter(e.currentTarget.value))
          );

          if (onBlur) {
            onBlur();
          }
          // Verify that sanitization needs to be done
          if (newValue !== parseFloat(currentValue)) {
            form.setFieldValue(field.name, newValue);
            form.setFieldTouched(field.name);
          }
        }}
        disabled={disabled}
      />
      <div className="input-group-append">
        <button
          disabled={disabled}
          className="btn button--input-group"
          aria-label="Increase by 1"
          onClick={() => {
            const newValue = enforceRange(Number(currentValue) + 1);

            form.setFieldValue(field.name, newValue);
            form.setFieldTouched(field.name);
            if (onChange) {
              onChange(newValue);
            }
          }}
          type="button"
        >
          <i className="fal fa-plus" />
        </button>
      </div>
    </div>
  );
};

StepperField.defaultProps = {
  className: '',
  onChange: null,
  onBlur: null,
  disabled: false,
};

StepperField.propTypes = {
  /* eslint-disable react/forbid-prop-types */
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  className: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  maxValue: PropTypes.number,
  minValue: PropTypes.number,
};

export default StepperField;
